import {
  EntryCustomComponents,
} from '@o3r/components';
/**
 * Helper function to register the custom components
 *
 * @example
 * {
 * const firstCompMap = registerCustomComponent(new Map(), 'firstCompKey', FirstComponent);
 * const secondCompMap = registerCustomComponent(firstCompMap, 'secondCompKey', SecondComponent);
 * return secondCompMap;
 * }
 */
export function registerCustomComponents(): Map<string, any> {
  return new Map<string, any>();
}

/** Returns the array of custom components and the array of associated components modules */
export function initializeEntryComponents(): EntryCustomComponents {
  return {
    customComponents: [],
    customComponentsModules: []
  };
}
